import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import CustomSidebar from "./Sidebar";
import CustomLoader from "./ux_ui/CustomLoader";
import React from "react";
import {Card} from "antd";

const ProtectedRoutes = () => {
    const { valid, isCheckingAuth } = useAuth();

    if (!valid && !isCheckingAuth) {
        return <Navigate to="/" replace />;
    }

    return (
        <>
            {valid && <CustomSidebar />}

            {isCheckingAuth && (
                <Card
                    style={{
                        width: "100vw",
                        height: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: 0,
                    }}
                >
                    <CustomLoader />
                </Card>
            )}
        </>
    );
};

export default ProtectedRoutes;

